import React, {ReactElement, ReactNode} from "react";
import classNames from "classnames";


import {ButtonProps} from "../Button"
import {IconProps} from "../icons";


import {DismissibleStorageStrategy, useDismissibleStorage} from "../../hooks/useDismissibleStorage";
import {CloseIcon} from "../icons/CloseIcon";


import "./Callout.css"


export interface CalloutProps {
    Icon?: React.ComponentType<IconProps>,
    text: ReactNode,
    button?: ReactElement<ButtonProps>,
    className?: string
    type: "info" | "ai" | "warning" | "danger" | "success"
    onClose?: () => void;
}

export const Callout = (
    (
        {
            Icon,
            text,
            button,
            className,
            type,
            onClose
        }: CalloutProps
    ) => (
        <div className={classNames({
            "Callout": true,
            "Callout--ai": type === 'ai',
            "Callout--info": type === 'info',
            "Callout--warning": type === 'warning',
            "Callout--danger": type === 'danger',
            "Callout--success": type === 'success',
            [className!]: className
        })}>
            {Icon &&
                <div className="Callout__icon">
                    <Icon className="Callout__iconSvg" size={20}/>
                </div>
            }
            <div className="Callout__text body-large">
                {text}
                {button &&
                    <div className="Callout__button">
                        {button}
                    </div>
                }
            </div>
            {onClose && (
                <CloseIcon className="Callout__closeIcon" size={20} onClick={onClose}/>
            )}
        </div>
    )
)

interface CalloutWithStorageProps extends Omit<CalloutProps, "onClose"> {
    storageKey: string;
    dismissStrategy?: DismissibleStorageStrategy;
}

export const CalloutWithStorage = (
    ({storageKey, dismissStrategy, ...rest}: CalloutWithStorageProps) => {
        const {isHidden, hide} = useDismissibleStorage({storageKey, strategy: dismissStrategy});

        if (isHidden) {
            return null;
        }

        return (
            <Callout
                {...rest}
                onClose={hide}
            />
        );
    }
)
